<template>
  <div class="footer">
    <b-container>
      <div class="bottom-banner" cols="12" v-if="adsFooter">
        <a
          :href="adsFooter.website"
          target="_blank"
          id="imageFooter"
          v-if="!adsFooter.advertisment_location.google_on"
          @click="CLICK_BANNERADS(adsFooter.id)"
        >
          <b-img
            :src="adsFooter.image"
            class="img-card"
            style="max-width:100%; height:auto;"
            :alt="
              adsFooter.website
                ? adsFooter.website
                : $t('altTag', {
                    affiliate: $root.affiliate,
                  })
            "
          ></b-img>
        </a>
        <!-- Footer -->
        <Adsense
          data-ad-test="false"
          v-else
          :in-style="
            isMobile ? '' : 'display:inline-block;width:970px;height:250px'
          "
          :data-ad-client="$root.googleClientId"
          :data-ad-slot="adsFooter.advertisment_location.google_ad_key"
          :data-full-width-responsive="isMobile ? true : false"
          :data-ad-format="isMobile ? 'auto' : 'horizontal'"
          :key="adsFooter.advertisment_location.google_ad_key"
        >
        </Adsense>
      </div>
    </b-container>

    <component :is="footerHtml" v-if="footerHtml" />

    <div
      v-if="!isMobile && $router.history.current.name != 'AddListing'"
      style="position:relative;z-index: 9;"
    >
      <div
        class="mt-19"
        style=" 
            position: fixed;
            right: 105px;
            bottom: 22px;
            height: 58px;
            box-shadow: 0 5px 4px 0 rgba(0,0,0,.26);
            border-radius: 40px;
            bottom:20px; 
            color:white;
            "
      >
        <button
          id="addListing"
          type="button"
          class="btn btn-post btn-primary"
          @click="gotoAddListing()"
          style="
            box-shadow: rgba(0, 0, 0, 0.26) 0px 5px 4px 0px;
            border-radius: 40px;
            padding: 0 30px;
            height: 58px;
            font-size: 20px;
            background: var(--projectPrimaryColor) !important;
						border-color: var(--projectPrimaryColor) !important;
            color:white;"
        >
          <svg
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            role="presentation"
            class="icon-list-add"
            style="color:white;filter: invert(1);"
          >
            <path
              d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
            ></path>
          </svg>
          {{ $t("post") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import getEnv from "@/utils/env";

export default {
  data() {
    return {};
  },
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
    adsFooter: {
      type: Object,
      default: function() {
        return {
          website: "#",
          image: "",
          advertisment_location: {
            google_on: false,
          },
        };
      },
    },
  },
  computed: {
    ...mapGetters("CategoryController", ["dataSearch"]),
    ...mapGetters("SiteConfigController", ["projectConfig"]),
    ...mapGetters("UserController", ["isMobile"]),

    footerHtml() {
      const template = this.projectConfig ? this.projectConfig.footer_html : "";
      return {
        template,
      };
    },
  },
  mounted() {
    if (document.cookie.indexOf("tr_cookies_partner=1") === -1) {
      console.log("if");
      this.show_cookie_consenst_div(true);
    }
  },
  created() {},
  methods: {
    ...mapActions("AdsController", [
      "GETADS_FOR_PUBLIC_WEBSITE",
      "CLICK_BANNERADS",
    ]),

    gotoAddListing() {
      if (this.$root.isAuthenticated) {
        this.$router.push(this.$i18nRoute({ name: "add-listing" }));
      } else {
        this.openThairathLogin();
      }
    },
    openThairathLogin() {
      this.$root.signIn("add-listing");
    },
  },
};
</script>
<style lang="scss">
@import "style";
</style>
